import { render } from "./RegisterView.vue?vue&type=template&id=4e55d924"
const script = {}

import exportComponent from "C:\\Codeframe\\Dev\\cdn\\pay\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__